const badges = [
  {
    name: "First Steps",
    description: "Complete 1 task",
    progress: 0,
    type: "rank",
    sentinel: 1
  },
  {
    name: "High Five",
    description: "Complete 5 tasks",
    progress: 0,
    type: "rank",
    sentinel: 5
  },
  {
    name: "Ben Ten",
    description: "Complete 10 tasks",
    progress: 0,
    type: "rank",
    sentinel: 10
  },
  {
    name: "Adult Tasker",
    description: "Complete 18 Tasks",
    progress: 0,
    type: "rank",
    sentinel: 18
  },
  {
    name: "Mid-Life Oasis",
    description: "Complete 50 tasks",
    progress: 0,
    type: "rank",
    sentinel: 50
  },
  {
    name: "Champion",
    description: "Complete 100 tasks",
    progress: 0,
    type: "rank",
    sentinel: 100
  },
  {
    name: "Hero",
    description: "Complete 200 tasks",
    progress: 0,
    type: "rank",
    sentinel: 200
  },
  {
    name: "Conquerer",
    description: "Complete 500 tasks",
    progress: 0,
    type: "rank",
    sentinel: 500
  },
  {
    name: "Absolute God",
    description: "Complete 1000 tasks",
    progress: 0,
    type: "rank",
    sentinel: 1000
  },
  {
    name: "Procastinator",
    description: "Complete 0 tasks in 7 days",
    progress: 0,
    type: "rank",
    sentinel: 0
  },
  {
    name: "Persistence is Key",
    description: "Work daily on a task for more than 7 days",
    progress: 0,
    type: "rank",
    sentinel: 7
  },
  {
    name: "Challenge Accepted",
    description: "Create a task",
    progress: 0,
    type: "rank",
    sentinel: 1
  }
]

export default badges;
